import { createActionGroup } from "@ngrx/store";
import { FacebookFormConfiguration } from "src/app/core/models/social-forms-configurations/facebook-form-configuration.model";
import { LeadInjector } from "src/app/core/models/lead/lead-injector.model";
import { leadInjectorTabs } from "./components/lead-injector-board-tab-group/lead-injector-board-tab-group.component";

export const LeadInjectorDashBoardAction = createActionGroup({
    source: 'LeadInjector',
    events: {
        'open injector info sidenav content': (injector: LeadInjector) => ({ injector }),
        'open facebook form info sidenav content': (formConfiguration: FacebookFormConfiguration) => ({ formConfiguration }),
        'board tab change': (selectedTab: leadInjectorTabs) => ({ selectedTab }),
        'social form facebook info view': (id: number) => ({ id }),
        'lead injector info view': (id: number) => ({ id })
    }
});